// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/Size.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { TextArea, view, css } from '@sail/ui';
import { EXAMPLE_TEXT } from './common';
export const Size = () => <view.div css={{
  layout: 'column',
  gap: 'medium',
  '& > *': {
    width: css.value('350px')
  }
}}>
    <TextArea label="Biography (large)" size="large" defaultValue={EXAMPLE_TEXT} />
    <TextArea label="Biography (medium, default)" size="medium" defaultValue={EXAMPLE_TEXT} />
    <TextArea label="Biography (small)" size="small" defaultValue={EXAMPLE_TEXT} />
  </view.div>;